import Blog from "../pages/app/Blog/Blog";
import BlogArticle from "../pages/app/BlogArticle/BlogArticle";
import FreeProxyServer from "../pages/app/FreeProxyServer/FreeProxyServer";
import HomePage from "../pages/app/Home/Home";
import NotFound from "../pages/app/NotFound/NotFound";
import BrowserInfo from "../pages/tools/BrowserInfo/BrowserInfo";
import CheckDatabase from "../pages/tools/CheckDatabase/CheckDatabase";
import CheckDns from "../pages/tools/CheckDns/CheckDns";
import CheckEvercookie from "../pages/tools/CheckEvercookie/CheckEvercookie";
import CheckWebrtc from "../pages/tools/CheckWebrtc/CheckWebrtc";
import FingerprintScanner from "../pages/tools/FingerprintScanner/FingerprintScanner";
import HeaderViewer from "../pages/tools/HeaderViewer/HeaderViewer";
import IpTracing from "../pages/tools/IpTracing/IpTracing";
import MyAnonymity from "../pages/tools/MyAnonymity/MyAnonymity";
import PortScanner from "../pages/tools/PortScaner/PortScanner";

export const appRoutes = (ssr = false) => [
  {
    path: "/:lang?",
    tag: "home",
    component: ssr ? HomePage : () => import("../pages/app/Home/Home"),
    isSsr: ssr ?? false,
  },
  {
    path: "/:lang?/tools/my-anonymity/",
    tag: "my-anonymity",
    component: ssr
      ? MyAnonymity
      : () => import("../pages/tools/MyAnonymity/MyAnonymity"),
    isSsr: ssr ?? false,
  },
  {
    path: "/:lang?/tools/check-dns/",
    tag: "check-dns",
    component: ssr
      ? CheckDns
      : () => import("../pages/tools/CheckDns/CheckDns"),
    isSsr: ssr ?? false,
  },
  {
    path: "/:lang?/tools/port-scanner/",
    tag: "port-scanner",
    component: ssr
      ? PortScanner
      : () => import("../pages/tools/PortScaner/PortScanner"),
    isSsr: ssr ?? false,
  },
  {
    path: "/:lang?/tools/ip-tracing/",
    tag: "ip-tracing",
    component: ssr
      ? IpTracing
      : () => import("../pages/tools/IpTracing/IpTracing"),
    isSsr: ssr ?? false,
  },
  {
    path: "/:lang?/tools/check-webrtc/",
    tag: "check-webrtc",
    component: ssr
      ? CheckWebrtc
      : () => import("../pages/tools/CheckWebrtc/CheckWebrtc"),
    isSsr: ssr ?? false,
  },
  {
    path: "/:lang?/tools/check-spam-database/",
    tag: "check-database",
    component: ssr
      ? CheckDatabase
      : () => import("../pages/tools/CheckDatabase/CheckDatabase"),
    isSsr: ssr ?? false,
  },
  {
    path: "/:lang?/tools/check-evercookie/",
    tag: "check-evercookie",
    component: ssr
      ? CheckEvercookie
      : () => import("../pages/tools/CheckEvercookie/CheckEvercookie"),
    isSsr: ssr ?? false,
  },
  {
    path: "/:lang?/tools/header-viewer/",
    tag: "header-viewer",
    component: ssr
      ? HeaderViewer
      : () => import("../pages/tools/HeaderViewer/HeaderViewer"),
    isSsr: ssr ?? false,
  },
  {
    path: "/:lang?/tools/browser-info/",
    tag: "browser-info",
    component: ssr
      ? BrowserInfo
      : () => import("../pages/tools/BrowserInfo/BrowserInfo"),
    isSsr: ssr ?? false,
  },
  {
    path: "/:lang?/tools/fingerprint-scanner/",
    tag: "fingerprint-scanner",
    component: ssr
      ? FingerprintScanner
      : () => import("../pages/tools/FingerprintScanner/FingerprintScanner"),
    isSsr: ssr ?? false,
  },
  {
    path: "/:lang?/blog/",
    tag: "blog",
    component: ssr ? Blog : () => import("../pages/app/Blog/Blog"),
    isSsr: ssr ?? false,
  },
  {
    path: "/:lang?/blog/:slug/",
    tag: "article",
    component: ssr
      ? BlogArticle
      : () => import("../pages/app/BlogArticle/BlogArticle"),
    isSsr: ssr ?? false,
  },
  {
    path: "/:lang?/free-proxy-server/",
    tag: "free-proxy-server",
    component: ssr
      ? FreeProxyServer
      : () => import("../pages/app/FreeProxyServer/FreeProxyServer"),
    isSsr: ssr ?? false,
  },
  {
    path: "/:lang?/not-found/",
    tag: "not-found",
    component: ssr ? NotFound : () => import("../pages/app/NotFound/NotFound"),
  },
];
